// extracted by mini-css-extract-plugin
module.exports = {"button":"GradientButton_button__GNF1H"};